// 导出页面为PDF格式
import { Main } from 'element-ui';
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { showLoading, hideLoading } from './loading';
// import Http from '@/libs/http.js'
// const qs = require('qs')

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function(element, title) {
      showLoading()
      html2Canvas(element, {
        allowTaint: true
      }).then(function(canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = (contentWidth / 592.28) * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        hideLoading()
        PDF.save(title + '.pdf')
        var datauri = PDF.output('dataurlstring')
        //去掉前面的字符串后，就是文件的加密字符串
        var base64 = datauri.substring(28)
        // Http.request({
        //   url: '/api/file/pdf',
        //   method: 'POST',
        //   showLoading: true,
        //   data: encodeURIComponent(encodeURIComponent(base64))
        // }).then(function(resp) {
        //   if (resp.code === 100) {
        //   }
        // })
      })
    }
  }
}
// 使用
// npm install html2canvas 
// npm install --save jspdf
// main.js 
//   import HtmlToPdf from '@/libs/html_to_pdf.js' 
//   Vue.use(HtmlToPdf)
